import _classCallCheck from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Lenovo\\igic-projetos\\Igic-Web\\Template\\Angle\\portal_profcontrol_cliente\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
// Licensed to the .NET Foundation under one or more agreements.
// The .NET Foundation licenses this file to you under the MIT license.
import { TextMessageFormat } from "./TextMessageFormat";
import { isArrayBuffer } from "./Utils";
/** @private */

export var HandshakeProtocol = /*#__PURE__*/function () {
  function HandshakeProtocol() {
    _classCallCheck(this, HandshakeProtocol);
  }

  _createClass(HandshakeProtocol, [{
    key: "writeHandshakeRequest",
    // Handshake request is always JSON
    value: function writeHandshakeRequest(handshakeRequest) {
      return TextMessageFormat.write(JSON.stringify(handshakeRequest));
    }
  }, {
    key: "parseHandshakeResponse",
    value: function parseHandshakeResponse(data) {
      var messageData;
      var remainingData;

      if (isArrayBuffer(data)) {
        // Format is binary but still need to read JSON text from handshake response
        var binaryData = new Uint8Array(data);
        var separatorIndex = binaryData.indexOf(TextMessageFormat.RecordSeparatorCode);

        if (separatorIndex === -1) {
          throw new Error("Message is incomplete.");
        } // content before separator is handshake response
        // optional content after is additional messages


        var responseLength = separatorIndex + 1;
        messageData = String.fromCharCode.apply(null, Array.prototype.slice.call(binaryData.slice(0, responseLength)));
        remainingData = binaryData.byteLength > responseLength ? binaryData.slice(responseLength).buffer : null;
      } else {
        var textData = data;

        var _separatorIndex = textData.indexOf(TextMessageFormat.RecordSeparator);

        if (_separatorIndex === -1) {
          throw new Error("Message is incomplete.");
        } // content before separator is handshake response
        // optional content after is additional messages


        var _responseLength = _separatorIndex + 1;

        messageData = textData.substring(0, _responseLength);
        remainingData = textData.length > _responseLength ? textData.substring(_responseLength) : null;
      } // At this point we should have just the single handshake message


      var messages = TextMessageFormat.parse(messageData);
      var response = JSON.parse(messages[0]);

      if (response.type) {
        throw new Error("Expected a handshake response from the server.");
      }

      var responseMessage = response; // multiple messages could have arrived with handshake
      // return additional data to be parsed as usual, or null if all parsed

      return [remainingData, responseMessage];
    }
  }]);

  return HandshakeProtocol;
}();